<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">Ordens de Serviço</strong>
              <a
                v-permission="'OrdemServico.Adicionar'"
                class="ml-auto btn btn-primary"
                href="/#/ordem-servico/novo"
                title="Adicionar nova ordem de serviço"
              >
                Adicionar
              </a>
            </div>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Situação</label>
                  <v-select
                    v-model="filtro.status"
                    placeholder="Todas as situações"
                    :options="situacoes"
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Equipe</label>
                  <v-select
                    v-model="filtro.team"
                    placeholder="Todas as equipes"
                    :options="equipes"
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Projeto</label>
                  <v-select
                    v-model="filtro.project"
                    placeholder="Todos os projetos"
                    :options="projetos"
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <button
                  class="btn btn-secondary mt-4"
                  type="button"
                  @click="ObterGrid(1)"
                >
                  Filtrar
                </button>
                <button
                  class="btn btn-link mt-4"
                  type="button"
                  @click="LimparFiltro"
                >
                  Limpar
                </button>
              </div>
            </div>

            <div v-if="loading" class="loading-container">
              <RotateSquare
                class="loading-position animated fadeIn"
                size="60px"
              ></RotateSquare>
            </div>
            <div v-else>
              <b-table
                :hover="true"
                responsive
                :items="itens"
                :fields="fields"
                striped
                :per-page="itensPorPagina"
                show-empty
                empty-text="Nenhuma ordem de serviço encontrada."
              >
                <template v-slot:empty="scope">
                  <h4>{{ scope.emptyText }}</h4>
                </template>
                <template v-slot:cell(scheduledDate)="data">
                  {{ FormatarData(data.item.scheduledDate) }}
                </template>
                <template v-slot:cell(statusName)="data">
                  <span
                    class="badge"
                    :class="'badge-' + Variante(data.item.status)"
                  >
                    {{ data.item.statusName }}
                  </span>
                </template>
                <template v-slot:cell(progresso)="data">
                  {{ data.item.executedItems }} / {{ data.item.totalItems }}
                  <small class="text-muted">
                    ({{ data.item.pendingItems }} pendentes)
                  </small>
                </template>
                <template v-slot:cell(acoes)="data">
                  <div class="btn-group-sm d-flex">
                    <b-button
                      variant="info"
                      style="margin-right: 10px"
                      title="Apontar execução"
                      v-permission="'OrdemServico.Executar'"
                      @click="Executar(data.item)"
                    >
                      <i class="fas fa-clipboard-check"></i>
                    </b-button>
                    <b-dropdown
                      size="sm"
                      variant="primary"
                      style="margin-right: 10px"
                      title="Alterar situação"
                      :disabled="Transicoes(data.item.status).length === 0"
                      text="Situação"
                      v-permission="'OrdemServico.Editar'"
                    >
                      <b-dropdown-item
                        v-for="transicao in Transicoes(data.item.status)"
                        :key="transicao.id"
                        @click="AlterarStatus(data.item, transicao)"
                      >
                        {{ transicao.label }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <b-button
                      variant="warning"
                      style="margin-right: 10px"
                      title="Editar"
                      :disabled="EhFinal(data.item.status)"
                      @click="Editar(data.item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button
                      variant="danger"
                      title="Remover"
                      v-permission="'OrdemServico.Remover'"
                      :disabled="data.item.status === statusEnum.Completed"
                      @click="Remover(data.item)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
              <b-pagination
                v-model="pagina"
                :total-rows="total"
                :per-page="itensPorPagina"
                align="right"
                size="md"
                class="mt-2"
              ></b-pagination>
            </div>

            <b-modal
              v-model="modalRemover"
              title="Confirmar exclusão"
              class="modal-danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              Você confirma a exclusão dessa ordem de serviço?
            </b-modal>

            <b-modal
              v-model="modalStatus"
              title="Alterar situação"
              ok-variant="primary"
              @ok="ModalStatusOk"
              @hidden="ModalStatusCancel"
            >
              <span v-if="statusDestino">
                Confirma alterar a situação da ordem de serviço para
                <strong>{{ statusDestino.label }}</strong
                >?
              </span>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import WorkOrderService from "../../servico/WorkOrderService";
import TeamService from "../../servico/TeamService";
import ProjectService from "../../servico/ProjectService";
import WorkOrderStatus from "../../enums/WorkOrderStatusEnum";
import DateTime from "../../util/DateTime";
import ApiError from "../../util/ApiError";

export default {
  name: "WorkOrder",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      modalRemover: false,
      itemRemover: null,
      modalStatus: false,
      itemStatus: null,
      statusDestino: null,
      statusEnum: WorkOrderStatus.Enum,
      situacoes: WorkOrderStatus.List,
      equipes: [],
      projetos: [],
      filtro: {
        status: null,
        team: null,
        project: null
      },
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 20,
      fields: [
        { key: "number", label: "Nº", sortable: true },
        { key: "title", label: "Título", sortable: true },
        { key: "teamName", label: "Equipe", sortable: true },
        { key: "scheduledDate", label: "Data prevista", sortable: true },
        { key: "statusName", label: "Situação", sortable: true },
        { key: "progresso", label: "Execução", sortable: false },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  beforeMount() {
    this.ObterEquipes();
    this.ObterProjetos();
    this.ObterGrid(1);
  },
  methods: {
    FormatarData(data) {
      return DateTime.FormatLocale(data) || "-";
    },
    Variante(status) {
      return WorkOrderStatus.Variant(status);
    },
    EhFinal(status) {
      return WorkOrderStatus.IsFinal(status);
    },
    Transicoes(status) {
      return WorkOrderStatus.AllowedTransitions(status);
    },
    Executar(item) {
      this.$router.push("/ordem-servico/execucao/" + item.id);
    },
    Editar(item) {
      this.$router.push("/ordem-servico/editar/" + item.id);
    },
    LimparFiltro() {
      this.filtro = { status: null, team: null, project: null };
      this.ObterGrid(1);
    },
    ObterEquipes() {
      TeamService.GetVSelect("")
        .then((resposta) => {
          this.equipes = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    ObterProjetos() {
      ProjectService.GetVSelect("    ", true)
        .then((resposta) => {
          this.projetos = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      WorkOrderService.Remove(this.itemRemover.id)
        .then(() => {
          this.itemRemover = null;
          this.ObterGrid(1);
          this.$notify({
            data: ["Ordem de serviço removida com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.itemRemover = null;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    AlterarStatus(item, transicao) {
      this.itemStatus = item;
      this.statusDestino = transicao;
      this.modalStatus = true;
    },
    ModalStatusCancel(evento) {
      evento.preventDefault();
      this.itemStatus = null;
      this.statusDestino = null;
    },
    ModalStatusOk(evento) {
      evento.preventDefault();
      this.modalStatus = false;
      if (!this.itemStatus || !this.statusDestino) return;

      let id = this.itemStatus.id;
      let destino = this.statusDestino.id;
      this.itemStatus = null;
      this.statusDestino = null;

      WorkOrderService.ChangeStatus(id, destino)
        .then(() => {
          this.ObterGrid(this.pagina);
          this.$notify({
            data: ["Situação alterada com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    MontarFiltro() {
      return {
        status: this.filtro.status ? this.filtro.status.id : null,
        teamId: this.filtro.team ? this.filtro.team.id : null,
        projectId: this.filtro.project ? this.filtro.project.id : null
      };
    },
    ObterGrid(pagina) {
      this.loading = true;

      WorkOrderService.GetGrid(pagina, this.MontarFiltro())
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
